import React, { useState } from 'react';
import InvalidPermissionsDialog from '../../../../components/invalid-permissions-dialog/InvalidPermissionsDialog';
import {
    FileData,
    replaceModalConfig,
    CreateJobDialog,
} from '../create-job-dialog';
import { styles } from './upload-data-dictionary-helper';
import { Grid, Typography } from '@mui/material';
import { DragAndDrop } from '@biq/apex-ui';
import { useAuth, usePermission } from '../../../../core';
import { useLocation, useNavigate } from 'react-router-dom';
import { useUploadDataDictionary } from 'hooks';
import { JOB_MANAGER_PATHS } from 'constants/job-manager-paths';
import { DICTIONARY_PATHS } from 'constants/dictionary-paths';

export const UploadDataDictionary = (): React.JSX.Element => {
    const { getToken, getUserEmail } = useAuth();
    const navigate = useNavigate();
    const { hasPermissions } = usePermission();
    const { mutate: uploadDataDictionary } = useUploadDataDictionary();
    const [files, setFiles] = useState<FileData[]>([]);
    const [fileError, setFileError] = useState<boolean>(false);
    const [displayPermissionDialog, setDisplayPermissionDialog] =
        useState(false);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const location = useLocation();

    const handleSubmit = (): void => {
        if (files.length === 0) {
            setFileError(true);
        } else {
            setFileError(false);
            setIsLoading(true);
            setTimeout(() => {
                if (location.state) {
                    navigate(DICTIONARY_PATHS.LANDING_PAGE);
                } else {
                    navigate(JOB_MANAGER_PATHS.LANDING_PAGE);
                }
            }, 500);
            uploadDataDictionary(
                {
                    files: files,
                    token: getToken(),
                    email: getUserEmail(),
                },
                {
                    onSuccess: () => {
                        setIsLoading(false);
                    },
                    onError: () => {
                        setIsLoading(false);
                    },
                }
            );
        }
    };

    const onSubmit = (): void => {
        const permission = hasPermissions(['createData', 'createMetadata']);
        if (permission) {
            handleSubmit();
        } else {
            setDisplayPermissionDialog(true);
        }
    };

    const handlePermissionDialogClose = (): void => {
        setDisplayPermissionDialog(false);
    };

    const handleCustomBackClick = (): void => {
        if (location.state) {
            navigate(`${DICTIONARY_PATHS.LANDING_PAGE}/${location.state}`);
        } else {
            navigate(JOB_MANAGER_PATHS.CREATE_NEW_JOB);
        }
    };

    const handleCustomCloseClick = (): void => {
        if (location.state) {
            navigate(`${DICTIONARY_PATHS.LANDING_PAGE}/${location.state}`);
        } else {
            navigate(JOB_MANAGER_PATHS.LANDING_PAGE);
        }
    };

    return (
        <CreateJobDialog
            buttonText='Start Upload'
            handleSubmit={onSubmit}
            isLoading={isLoading}
            handleCustomBackClick={handleCustomBackClick}
            handleCustomCloseClick={handleCustomCloseClick}
        >
            <Grid mt={1.5}>
                <Typography sx={styles.uploadDataDictionaryText}>
                    Must be a JSON file. Uploading a data dictionary will
                    <br />
                    alter the indexes to match the data file.
                </Typography>
            </Grid>
            <Grid mt={3} mx={'143.5px'}>
                <Grid>
                    <DragAndDrop
                        files={files}
                        setFiles={setFiles}
                        fileError={fileError}
                        setFileError={setFileError}
                        filePreview={true}
                        showReplaceFileModal={true}
                        replaceModalConfig={replaceModalConfig}
                    />
                </Grid>
            </Grid>
            {displayPermissionDialog && (
                <InvalidPermissionsDialog
                    open={displayPermissionDialog}
                    onClose={handlePermissionDialogClose}
                />
            )}
        </CreateJobDialog>
    );
};
